import type { INotificationRepository } from "@/application/ports/repositories";
import type {
	Notification,
	NotificationStats,
	NotificationListResponse,
	GetNotificationsParams,
} from "@/domain";
import { apiClient } from "../client";

export class NotificationRepository implements INotificationRepository {
	private basePath = "/notifications";

	async getNotifications(
		params?: GetNotificationsParams,
	): Promise<NotificationListResponse> {
		const queryParams = new URLSearchParams();

		if (params?.limit) queryParams.append("limit", params.limit.toString());
		if (params?.offset) queryParams.append("offset", params.offset.toString());
		if (params?.is_read !== undefined)
			queryParams.append("is_read", params.is_read.toString());
		if (params?.notification_type)
			queryParams.append("notification_type", params.notification_type);
		if (params?.search) queryParams.append("search", params.search);
		if (params?.created_after)
			queryParams.append("created_after", params.created_after);
		if (params?.created_before)
			queryParams.append("created_before", params.created_before);

		const queryString = queryParams.toString();
		const url = `${this.basePath}${queryString ? `?${queryString}` : ""}`;

		const response = await apiClient.get<NotificationListResponse>(url);
		return response.data;
	}
	async getNotificationStats(): Promise<NotificationStats> {
		const response = await apiClient.get<NotificationStats>(
			`${this.basePath}/stats`,
		);
		return response.data;
	}
	async getNotification(uuid: string): Promise<Notification> {
		const response = await apiClient.get<Notification>(
			`${this.basePath}/${uuid}`,
		);
		return response.data;
	}
	async markAsRead(uuid: string): Promise<void> {
		await apiClient.post(`${this.basePath}/${uuid}/mark-as-read`);
	}
	async markAsUnread(uuid: string): Promise<void> {
		await apiClient.post(`${this.basePath}/${uuid}/mark-as-unread`);
	}
	async markAllAsRead(): Promise<void> {
		await apiClient.post(`${this.basePath}/mark-all-read`);
	}
	async deleteNotification(uuid: string): Promise<void> {
		await apiClient.delete(`${this.basePath}/${uuid}`);
	}
	async deleteAllNotifications(): Promise<void> {
		await apiClient.delete(this.basePath);
	}
}
